// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@keyframes oa-rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes oa-blink {
  0%, 60%, 100% {
    opacity: 0.25;
  }
  30% {
    opacity: 1;
  }
}
@keyframes oa-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(20, 20, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(20, 20, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(20, 20, 255, 0);
  }
}
#owen-bot {
  --p1: #f5f5ff;
  --p2: #d8d8ff;
  --p3: #8686ff;
  --p4: #4343ff;
  --p5: #1414ff;
  --p6: #0000c9;
  --p7: #000093;
  --p8: #00007a;
  --p9: #000054;
  --n2: #f9f9fa;
  --n4: #e0e0e3;
  --n8: #838390;
  --ok: #126f0e;
  --ok1: #f4fced;
  --ok5: #58b441;
  --warn: #b94402;
  --warn1: #fef9f0;
  --warn3: #fbd298;
  --dng: #911727;
  --dng1: #fdf1ed;
  --dng3: #f4ada1;
  --cb-accent: var(--p5);
  --cb-accent-hover: var(--p6);
  --cb-border: var(--p8);
  --cb-reply-bg: var(--p1);
  --cb-reply-text: var(--p8);
  --cb-text: var(--p8);
  --cb-dark: var(--p9);
  --cb-dot: var(--ok5);
  --cb-topbar-display: flex;
  --cb-ovbar-bg: var(--cb-dark);
  --cb-ovbar-fg: #fff;
  --cb-ovbtn-bg: rgba(255,255,255,.14);
  --cb-ovbtn-border: rgba(255,255,255,.28);
  --cb-ovbtn-hover: rgba(255,255,255,.26);
  font-family: "Lexend", sans-serif;
  font-weight: 300;
}

#ob-fab {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 50;
  display: flex;
  align-items: center;
  gap: 10px;
  border: none;
  cursor: pointer;
  background: var(--cb-accent);
  color: #fff;
  border-radius: 30px;
  padding: 12px 18px 12px 14px;
  box-shadow: 0 8px 24px rgba(0, 0, 21, 0.28);
  font-size: 15px;
  font-weight: 500;
  font-family: "Lexend", sans-serif;
}
#ob-fab:hover {
  background: var(--cb-accent-hover);
}
#ob-fab svg {
  width: 22px;
  height: 22px;
}

#owen-bot .ob-fab-label { /* visible par défaut, caché en ≤600px */ }

#ob-overlay {
  position: fixed;
  z-index: 60;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0, 0, 21, 0.45);
  display: flex;
  flex-direction: column;
  transition: all 0.22s ease;
}
#ob-overlay[hidden] {
  display: none;
}

.size-sm #ob-overlay {
  right: 24px;
  bottom: 24px;
  left: auto;
  top: auto;
  width: 400px;
  height: 600px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 48px);
}

.size-lg #ob-overlay {
  inset: 14px;
  width: auto;
  height: auto;
}

.ob-ovbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 14px;
  background: var(--cb-ovbar-bg);
  color: var(--cb-ovbar-fg);
  flex: none;
}

.ob-ovtitle {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 13.5px;
  font-weight: 500;
  min-width: 0;
}
.ob-ovtitle svg {
  width: 58px;
  height: auto;
  flex: none;
}
.ob-ovtitle span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ob-ovactions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: none;
}

.ob-ovbtn {
  background: var(--cb-ovbtn-bg);
  border: 1px solid var(--cb-ovbtn-border);
  color: inherit;
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
}
.ob-ovbtn:hover {
  background: var(--cb-ovbtn-hover);
}

.ob-icobtn {
  width: 34px;
  height: 34px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
}

.size-sm .ob-tg-shrink {
  display: none;
}

.size-lg .ob-tg-grow {
  display: none;
}

.size-sm #ob-asst .stage {
  grid-template-columns: 1fr;
}

.size-sm #ob-asst .dossier {
  display: none;
}

.size-sm #ob-asst .topbar {
  display: none;
}

.size-sm #ob-asst .chat {
  border-right: none;
}

.embed .tbtn.espace {
  display: none;
}

@media (max-width: 600px) {
  #owen-bot .ob-fab-label {
    display: none;
  }
  .size-sm #ob-overlay,
  .size-lg #ob-overlay {
    inset: 0;
    width: auto;
    height: auto;
    max-width: none;
    max-height: none;
    border-radius: 0;
  }
  .size-sm #ob-asst .stage {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }
  .size-sm #ob-asst .dossier {
    display: none;
  }
  .size-lg #ob-asst .stage {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
  }
  .size-lg #ob-asst .dossier {
    max-height: 38vh;
  }
  .ob-ovbar {
    padding: 9px 12px;
  }
  .ob-ovtitle span {
    display: none;
  }
  .ob-ovbtn {
    padding: 6px 10px;
    font-size: 12px;
  }
}
#ob-asst {
  position: relative;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: var(--n2);
  color: var(--cb-text);
}
#ob-asst * {
  box-sizing: border-box;
  font-family: "Lexend", sans-serif;
}
#ob-asst a {
  color: inherit;
}
#ob-asst .topbar {
  display: var(--cb-topbar-display);
  align-items: center;
  justify-content: space-between;
  padding: 14px 28px;
  background: var(--cb-dark);
  color: #fff;
  flex: none;
}
#ob-asst .topbar .brand {
  display: flex;
  align-items: center;
  gap: 14px;
}
#ob-asst .topbar .brand svg {
  width: 78px;
  height: auto;
}
#ob-asst .tbtns {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
#ob-asst .tbtn {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: #fff;
  border-radius: 8px;
  padding: 8px 13px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
#ob-asst .tbtn:hover {
  background: rgba(255, 255, 255, 0.22);
}
#ob-asst .tbtn.on {
  background: #fff;
  color: var(--cb-dark);
}
#ob-asst .embed .tbtn.espace {
  display: none;
}
#ob-asst .stage {
  flex: 1 1;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 0;
  min-height: 0;
}
#ob-asst .stage.solo {
  grid-template-columns: 1fr;
}
#ob-asst .stage.solo .dossier {
  display: none;
}
#ob-asst .chat {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  border-right: 1px solid var(--n4);
  background: #fff;
}
#ob-asst .chat-head {
  padding: 16px 22px;
  border-bottom: 1px solid var(--n4);
  display: flex;
  align-items: center;
  gap: 12px;
}
#ob-asst .chat-head .av {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--cb-dark);
  display: flex;
  align-items: center;
  justify-content: center;
}
#ob-asst .chat-head .av svg {
  width: 30px;
}
#ob-asst .chat-head .nm {
  font-weight: 600;
  font-size: 16px;
}
#ob-asst .chat-head .st {
  font-size: 12px;
  color: var(--n8);
}
#ob-asst .chat-head .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--cb-dot);
  display: inline-block;
  margin-right: 5px;
}
#ob-asst .chat-head .ob-download-btn {
  margin-left: auto;
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 50%;
  border: 1px solid var(--n4);
  background: #fff;
  color: var(--p6);
  font-size: 16px;
  cursor: pointer;
}
#ob-asst .chat-head .ob-download-btn:hover {
  background: var(--n2);
}
#ob-asst .log {
  flex: 1 1;
  overflow-y: auto;
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: linear-gradient(180deg, #fff, var(--n2));
}
#ob-asst .msg {
  max-width: 82%;
  padding: 11px 15px;
  border-radius: 16px;
  font-size: 14.5px;
  line-height: 1.55;
  white-space: pre-wrap;
  animation: oa-rise 0.35s ease both;
}
#ob-asst .bot {
  align-self: flex-start;
  background: var(--cb-reply-bg);
  color: var(--cb-reply-text);
  border-bottom-left-radius: 5px;
}
#ob-asst .user {
  align-self: flex-end;
  background: var(--p5);
  color: #fff;
  border-bottom-right-radius: 5px;
}
#ob-asst .bot strong {
  color: var(--cb-accent);
}
#ob-asst .user strong {
  color: #fff;
}
#ob-asst .msg.alert {
  background: var(--warn1);
  color: var(--warn);
  border: 1px solid var(--warn3);
}
#ob-asst .msg.alert strong {
  color: var(--warn);
}
#ob-asst .sys {
  align-self: center;
  font-size: 12.5px;
  color: var(--n8);
  background: #fff;
  border: 1px dashed var(--n4);
  border-radius: 20px;
  padding: 5px 14px;
}
#ob-asst .typing-wrap {
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  gap: 5px;
  animation: oa-rise 0.35s ease both;
}
#ob-asst .typing-who {
  font-size: 12px;
  color: var(--p5);
  font-style: italic;
  padding-left: 4px;
}
#ob-asst .typing {
  align-self: flex-start;
  display: flex;
  gap: 5px;
  padding: 13px 16px;
  background: var(--p1);
  border-radius: 16px;
  border-bottom-left-radius: 5px;
}
#ob-asst .typing span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--p3);
  animation: oa-blink 1s infinite;
}
#ob-asst .typing span:nth-child(2) {
  animation-delay: 0.18s;
}
#ob-asst .typing span:nth-child(3) {
  animation-delay: 0.36s;
}
#ob-asst .quick {
  padding: 0 22px 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
  background: var(--n2);
}
#ob-asst .composer {
  display: flex;
  gap: 8px;
  padding: 12px 22px;
  border-top: 1px solid var(--n4);
  background: #fff;
}
#ob-asst .composer textarea {
  flex: 1 1;
  height: 42px;
  max-height: 120px;
  padding: 10px 14px;
  border: 1px solid var(--cb-border);
  border-radius: 10px;
  outline: none;
  font-family: inherit;
  font-size: 14.5px;
  line-height: 1.4;
  color: var(--p8);
  resize: none;
  overflow-y: auto;
}
#ob-asst .composer textarea:focus {
  border-color: var(--cb-accent);
}
#ob-asst .composer button {
  align-self: flex-end;
  border: none;
  background: var(--cb-accent);
  color: #fff;
  border-radius: 10px;
  padding: 0 18px;
  height: 42px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}
#ob-asst .composer button:hover {
  background: var(--cb-accent-hover);
}
#ob-asst .composer button:disabled {
  background: var(--p2);
  cursor: default;
}
#ob-asst .chip {
  border: 1px solid var(--cb-accent);
  background: #fff;
  color: var(--cb-accent-hover);
  border-radius: 20px;
  padding: 9px 15px;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
  animation: oa-rise 0.3s ease both;
  transition: 0.12s;
}
#ob-asst .chip:hover {
  background: var(--cb-reply-bg);
}
#ob-asst .chip.cta {
  background: var(--cb-accent);
  color: #fff;
  border-color: var(--cb-accent);
}
#ob-asst .chip.cta:hover {
  background: var(--cb-accent-hover);
}
#ob-asst .chip.ghost {
  border-color: var(--n4);
  color: var(--n8);
}
#ob-asst .chip.adu-chip-done {
  border-color: #3a9c3a;
  color: #3a9c3a;
  background: #f0faf0;
  cursor: default;
}
#ob-asst .chip.adu-chip-rejected {
  border-color: #d64545;
  color: #d64545;
  background: #fdecec;
}
#ob-asst .chip.adu-chip-forced {
  border-color: var(--warn);
  color: var(--warn);
  background: var(--warn1);
  cursor: default;
}
#ob-asst .msg-inline-action {
  align-self: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  animation: oa-rise 0.35s ease both;
}
#ob-asst .msg-inline-action .inline-cta {
  background: var(--cb-accent);
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.12s;
}
#ob-asst .msg-inline-action .inline-cta:hover {
  background: var(--cb-accent-hover);
}
#ob-asst .msg-inline-action .inline-cta:disabled {
  background: var(--p3);
  cursor: default;
}
#ob-asst .msg-inline-action .inline-ghost {
  background: #fff;
  color: var(--cb-accent-hover);
  border: 1px solid var(--cb-accent);
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.12s;
}
#ob-asst .msg-inline-action .inline-ghost:hover {
  background: var(--cb-reply-bg);
}
#ob-asst .ob-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  margin-left: 4px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  vertical-align: middle;
  color: var(--p9);
}
#ob-asst .ob-info-icon svg {
  width: 100%;
  height: 100%;
}
#ob-asst .ob-info-icon:hover {
  color: var(--p6);
}
#ob-asst .ob-info-tooltip {
  position: absolute;
  z-index: 30;
  width: 240px;
  max-width: calc(100vw - 64px);
  background: #fff;
  color: var(--p8);
  border: 1px solid var(--n4);
  border-radius: 12px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
  padding: 16px 14px 14px;
  font-size: 12.5px;
  line-height: 1.5;
  font-weight: 400;
}
#ob-asst .ob-info-tooltip[hidden] {
  display: none;
}
#ob-asst .ob-info-tooltip .ob-info-close {
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  border: none;
  color: var(--n8);
  font-size: 13px;
  line-height: 1;
  padding: 4px;
  cursor: pointer;
}
#ob-asst .ob-info-tooltip .ob-info-close:hover {
  color: var(--p8);
}
#ob-asst .ob-info-tooltip .ob-info-body {
  max-height: 280px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
#ob-asst .ob-info-tooltip .ob-info-body::-webkit-scrollbar {
  display: none;
}
#ob-asst .ob-info-tooltip .ob-info-body p {
  margin: 0 0 8px;
}
#ob-asst .ob-info-tooltip .ob-info-body a {
  display: inline-block;
  margin-bottom: 8px;
  color: var(--p5);
  font-weight: 500;
}
#ob-asst .ob-info-tooltip .ob-info-body .ob-info-human-btn {
  display: block;
  width: 100%;
  margin-top: 4px;
  background: var(--p1);
  border: none;
  border-radius: 10px;
  padding: 8px 10px;
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  color: var(--p6);
  cursor: pointer;
}
#ob-asst .ob-info-tooltip .ob-info-body .ob-info-human-btn:hover {
  background: var(--p2);
}
#ob-asst .dossier {
  overflow-y: auto;
  padding: 22px;
  background: var(--n2);
  display: flex;
  flex-direction: column;
  gap: 16px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
#ob-asst .dossier::-webkit-scrollbar {
  display: none;
}
#ob-asst .dossier h2 {
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--n8);
  margin: 0 0 2px;
}
#ob-asst .panel {
  background: #fff;
  border: 1px solid var(--n4);
  border-radius: 14px;
  padding: 16px 18px;
}
#ob-asst .panel.empty {
  opacity: 0.45;
}
#ob-asst .panel .ttl {
  font-size: 13px;
  font-weight: 600;
  color: var(--p7);
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
#ob-asst .kv {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13.5px;
  padding: 3px 0;
}
#ob-asst .kv .k {
  color: var(--n8);
}
#ob-asst .kv .v {
  font-weight: 500;
  text-align: right;
}
#ob-asst .badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 9px;
  border-radius: 20px;
}
#ob-asst .badge.risk-low {
  background: var(--ok1);
  color: var(--ok);
}
#ob-asst .badge.risk-med {
  background: var(--warn1);
  color: var(--warn);
}
#ob-asst .badge.risk-high {
  background: var(--dng1);
  color: var(--dng);
}
#ob-asst .tracker {
  display: flex;
  flex-direction: column;
  gap: 0;
}
#ob-asst .tstep {
  display: flex;
  gap: 11px;
  align-items: flex-start;
  position: relative;
  padding-bottom: 14px;
}
#ob-asst .tstep:last-child {
  padding-bottom: 0;
}
#ob-asst .tstep::before {
  content: "";
  position: absolute;
  left: 8px;
  top: 18px;
  bottom: 0;
  width: 2px;
  background: var(--n4);
}
#ob-asst .tstep:last-child::before {
  display: none;
}
#ob-asst .tstep .ic {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid var(--n4);
  background: #fff;
  flex: none;
  margin-top: 1px;
  transition: 0.25s;
}
#ob-asst .tstep .lb {
  font-size: 13.5px;
  color: var(--n8);
  transition: 0.25s;
}
#ob-asst .tstep.done .ic {
  background: var(--p5);
  border-color: var(--p5);
  box-shadow: 0 0 0 3px var(--p1);
}
#ob-asst .tstep.done .lb {
  color: var(--p8);
  font-weight: 500;
}
#ob-asst .tstep.active .ic {
  border-color: var(--p5);
  animation: oa-pulse 1.2s infinite;
}
#ob-asst .tstep.active .lb {
  color: var(--p6);
  font-weight: 600;
}
#ob-asst .row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13.5px;
  padding: 7px 0;
  border-bottom: 1px solid var(--n2);
  animation: oa-rise 0.3s ease both;
}
#ob-asst .row:last-child {
  border-bottom: none;
}
#ob-asst .row .st {
  margin-left: auto;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
}
#ob-asst .row .st.ok {
  background: var(--ok1);
  color: var(--ok);
}
#ob-asst .row .st.review {
  background: var(--warn1);
  color: var(--warn);
}
#ob-asst .row .st.wait {
  background: var(--p1);
  color: var(--p6);
}
#ob-asst .row .ocr {
  display: block;
  font-size: 11.5px;
  color: var(--n8);
  font-weight: 400;
  margin-top: 2px;
}
#ob-asst .chk {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
#ob-asst .chk.ok {
  background: var(--ok5);
}
#ob-asst .chk.review {
  background: var(--warn3);
}
#ob-asst .chk.wait {
  background: var(--n4);
}
#ob-asst .chk svg {
  width: 10px;
  height: 10px;
}
#ob-asst .calc {
  margin-top: 4px;
}
#ob-asst .calc .line {
  display: flex;
  justify-content: space-between;
  font-size: 13.5px;
  padding: 5px 0;
  border-bottom: 1px dashed var(--n4);
}
#ob-asst .calc .line.neg .v {
  color: var(--warn);
}
#ob-asst .calc .total {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 700;
  color: var(--p8);
  padding-top: 9px;
}
#ob-asst .dstat {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
  margin-bottom: 10px;
}
#ob-asst .dstat.partial {
  background: var(--warn1);
  color: var(--warn);
}
#ob-asst .dstat.escalate {
  background: var(--p1);
  color: var(--p6);
}
#ob-asst .note {
  font-size: 12.5px;
  color: var(--n8);
  margin-top: 10px;
  line-height: 1.5;
}
#ob-asst .picker {
  position: absolute;
  inset: 0;
  background: var(--p9);
  background-image: radial-gradient(circle at 80% 10%, rgba(67, 67, 255, 0.4), transparent 45%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  z-index: 20;
}
#ob-asst .picker .logo {
  margin-bottom: 18px;
}
#ob-asst .picker .logo svg {
  width: 96px;
}
#ob-asst .picker h1 {
  color: #fff;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  margin: 0 0 6px;
}
#ob-asst .picker p {
  color: var(--p2);
  font-size: 15px;
  text-align: center;
  max-width: 520px;
  margin: 0 0 28px;
  font-weight: 300;
}
#ob-asst .cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 260px));
  gap: 14px;
}
#ob-asst .scard {
  background: #fff;
  border-radius: 14px;
  padding: 18px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: 0.15s;
  text-align: left;
}
#ob-asst .scard:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 30px rgba(0, 0, 21, 0.35);
}
#ob-asst .scard .emo {
  font-size: 24px;
}
#ob-asst .scard .t {
  font-weight: 600;
  color: var(--p8);
  margin: 8px 0 3px;
  font-size: 16px;
}
#ob-asst .scard .d {
  font-size: 12.5px;
  color: var(--n8);
  line-height: 1.45;
}
#ob-asst .hide {
  display: none !important;
}
@media (max-width: 880px) {
  #ob-asst .stage {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
  }
  #ob-asst .chat {
    border-right: none;
    border-bottom: 1px solid var(--n4);
  }
  #ob-asst .dossier {
    max-height: 40vh;
  }
  #ob-asst .topbar {
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 14px;
  }
  #ob-asst .tbtns {
    width: 100%;
    justify-content: flex-start;
  }
  #ob-asst .tbtn {
    padding: 7px 10px;
    font-size: 12px;
  }
}
@media (max-width: 600px) {
  #ob-asst .topbar .brand .tag {
    display: none;
  }
  #ob-asst .msg {
    max-width: 90%;
  }
  #ob-asst .quick {
    padding: 0 14px 10px;
  }
  #ob-asst .composer {
    padding: 10px 14px;
  }
  #ob-asst .cards {
    grid-template-columns: 1fr;
  }
}

.composer-suggestions {
  padding: 0 14px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.composer-suggestions .sugg-item {
  background: var(--n2);
  border: 1px solid var(--n4);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 300;
  font-family: "Lexend", sans-serif;
  color: var(--p7);
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background 0.15s;
}
.composer-suggestions .sugg-item:hover {
  background: var(--p1);
  border-color: var(--p3);
}`, "",{"version":3,"sources":["webpack://./src/components/OwenAssistant/OwenAssistant.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE;IAAO,UAAA;IAAY,0BAAA;EAGnB;EAFA;IAAO,UAAA;IAAY,eAAA;EAMnB;AACF;AALA;EACE;IAAgB,aAAA;EAQhB;EAPA;IAAiB,UAAA;EAUjB;AACF;AATA;EACE;IAAO,0CAAA;EAYP;EAXA;IAAO,0CAAA;EAcP;EAbA;IAAO,wCAAA;EAgBP;AACF;AAbA;EAEE,aAAA;EAAe,aAAA;EAAe,aAAA;EAAe,aAAA;EAC7C,aAAA;EAAe,aAAA;EAAe,aAAA;EAAe,aAAA;EAAe,aAAA;EAC5D,aAAA;EAAe,aAAA;EAAe,aAAA;EAC9B,aAAA;EAAe,cAAA;EAAgB,cAAA;EAC/B,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EACnC,cAAA;EAAgB,eAAA;EAAiB,eAAA;EAOjC,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAKA,yBAAA;EAIA,6BAAA;EACA,mBAAA;EACA,oCAAA;EACA,wCAAA;EACA,uCAAA;EAEA,iCAAA;EACA,gBAAA;AAeF;;AAXA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;EACA,WAAA;EACA,mBAAA;EACA,4BAAA;EACA,2CAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAcF;AAZE;EAAU,kCAAA;AAeZ;AAbE;EAAM,WAAA;EAAa,YAAA;AAiBrB;;AAdA,0BAAA,wCAAA,EAAA;;AAGA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;AAgBF;AAdE;EAAY,aAAA;AAiBd;;AAdA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,8BAAA;AAiBF;;AAdA;EACE,WAAA;EACA,WAAA;EACA,YAAA;AAiBF;;AAbA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,8BAAA;EACA,yBAAA;EACA,UAAA;AAgBF;;AAbA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAgBF;AAdE;EAAO,WAAA;EAAa,YAAA;EAAc,UAAA;AAmBpC;AAlBE;EAAO,mBAAA;EAAqB,gBAAA;EAAkB,uBAAA;AAuBhD;;AApBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;AAuBF;;AApBA;EACE,8BAAA;EACA,wCAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AAuBF;AArBE;EAAU,iCAAA;AAwBZ;;AArBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAwBF;;AApBA;EAAyB,aAAA;AAwBzB;;AAvBA;EAAyB,aAAA;AA2BzB;;AAxBA;EAA6B,0BAAA;AA4B7B;;AA3BA;EAA6B,aAAA;AA+B7B;;AA9BA;EAA6B,aAAA;AAkC7B;;AAjCA;EAA6B,kBAAA;AAqC7B;;AAlCA;EAAsB,aAAA;AAsCtB;;AAnCA;EACE;IAA0B,aAAA;EAuC1B;EArCA;;IAEE,QAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;EAuCF;EApCA;IAA4B,0BAAA;IAA4B,uBAAA;EAwCxD;EAvCA;IAA6B,aAAA;EA0C7B;EAzCA;IAA6B,0BAAA;IAA4B,4BAAA;EA6CzD;EA5CA;IAA6B,gBAAA;EA+C7B;EA7CA;IAAY,iBAAA;EAgDZ;EA/CA;IAAmB,aAAA;EAkDnB;EAjDA;IAAY,iBAAA;IAAmB,eAAA;EAqD/B;AACF;AAlDA;EAGE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;AAkDF;AA3DE;EAAI,sBAAA;EAAwB,iCAAA;AA+D9B;AApDE;EAAI,cAAA;AAuDN;AApDE;EACE,iCAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,UAAA;AAsDJ;AApDI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAsDN;AApDM;EAAM,WAAA;EAAa,YAAA;AAwDzB;AAnDE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAqDJ;AAlDE;EACE,qCAAA;EACA,2CAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAoDJ;AAlDI;EAAU,qCAAA;AAqDd;AApDI;EAAO,gBAAA;EAAkB,qBAAA;AAwD7B;AArDE;EAAsB,aAAA;AAwDxB;AArDE;EACE,SAAA;EACA,aAAA;EACA,oCAAA;EACA,MAAA;EACA,aAAA;AAuDJ;AArDI;EAAS,0BAAA;AAwDb;AAvDI;EAAkB,aAAA;AA0DtB;AAtDE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,iCAAA;EACA,gBAAA;AAwDJ;AArDE;EACE,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAuDJ;AArDI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAuDN;AArDM;EAAM,WAAA;AAwDZ;AArDI;EAAM,gBAAA;EAAkB,eAAA;AAyD5B;AAxDI;EAAM,eAAA;EAAiB,gBAAA;AA4D3B;AA3DI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;AA6DN;AA1DI;EACE,iBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AA4DN;AA1DM;EAAU,qBAAA;AA6DhB;AAzDE;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oDAAA;AA2DJ;AAxDE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kCAAA;AA0DJ;AAvDE;EAAQ,sBAAA;EAAwB,8BAAA;EAAgC,2BAAA;EAA6B,8BAAA;AA6D/F;AA5DE;EAAQ,oBAAA;EAAwB,qBAAA;EAAuB,WAAA;EAAmB,+BAAA;AAkE5E;AAjEE;EAAe,uBAAA;AAoEjB;AAnEE;EAAe,WAAA;AAsEjB;AAnEE;EACE,wBAAA;EACA,kBAAA;EACA,8BAAA;AAqEJ;AApEI;EAAS,kBAAA;AAuEb;AApEE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;AAsEJ;AAnEE;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kCAAA;AAqEJ;AAlEE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAoEJ;AAjEE;EACE,sBAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BAAA;AAmEJ;AAjEI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,+BAAA;AAmEN;AAjEM;EAAiB,sBAAA;AAoEvB;AAnEM;EAAiB,sBAAA;AAsEvB;AAlEE;EACE,oBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,qBAAA;AAoEJ;AAjEE;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;AAmEJ;AAjEI;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAmEN;AAjEM;EAAU,8BAAA;AAoEhB;AAjEI;EACE,oBAAA;EACA,YAAA;EACA,4BAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAmEN;AAjEM;EAAW,kCAAA;AAoEjB;AAnEM;EAAa,qBAAA;EAAuB,eAAA;AAuE1C;AAlEE;EACE,kCAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,iCAAA;EACA,iBAAA;AAoEJ;AAlEI;EAAW,8BAAA;AAqEf;AApEI;EAAW,4BAAA;EAA8B,WAAA;EAAa,8BAAA;AAyE1D;AAxEI;EAAc,kCAAA;AA2ElB;AA1EI;EAAW,uBAAA;EAAyB,gBAAA;AA8ExC;AA7EI;EAAkB,qBAAA;EAAuB,cAAA;EAAgB,mBAAA;EAAqB,eAAA;AAmFlF;AAjFI;EAAsB,qBAAA;EAAuB,cAAA;EAAgB,mBAAA;AAsFjE;AApFI;EAAoB,yBAAA;EAA2B,kBAAA;EAAoB,wBAAA;EAA0B,eAAA;AA0FjG;AAtFE;EACE,sBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,kCAAA;AAwFJ;AAtFI;EACE,4BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BAAA;AAwFN;AAtFM;EAAa,kCAAA;AAyFnB;AAxFM;EAAa,qBAAA;EAAuB,eAAA;AA4F1C;AAzFI;EACE,gBAAA;EACA,6BAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BAAA;AA2FN;AAzFM;EAAU,8BAAA;AA4FhB;AApFE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AAsFJ;AApFI;EAAM,WAAA;EAAa,YAAA;AAwFvB;AAtFI;EAAU,gBAAA;AAyFd;AAtFE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,2CAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAwFJ;AAtFI;EAAY,aAAA;AAyFhB;AAvFI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AAyFN;AAvFM;EAAU,gBAAA;AA0FhB;AAtFI;EACE,iBAAA;EACA,gBAAA;EAGA,qBAAA;EACA,wBAAA;AAsFN;AApFM;EAAuB,aAAA;AAuF7B;AArFM;EAAI,eAAA;AAwFV;AAvFM;EAAI,qBAAA;EAAuB,kBAAA;EAAoB,gBAAA;EAAkB,gBAAA;AA6FvE;AA3FM;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;AA6FR;AA3FQ;EAAU,qBAAA;AA8FlB;AAxFE;EACE,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EAGA,qBAAA;EACA,wBAAA;AAwFJ;AAtFI;EAAuB,aAAA;AAyF3B;AAvFI;EACE,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AAyFN;AArFE;EACE,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;AAuFJ;AArFI;EAAU,aAAA;AAwFd;AAtFI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAwFN;AApFE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAsFJ;AApFI;EAAK,gBAAA;AAuFT;AAtFI;EAAK,gBAAA;EAAkB,iBAAA;AA0F3B;AAvFE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAyFJ;AAvFI;EAAc,sBAAA;EAA0B,gBAAA;AA2F5C;AA1FI;EAAc,wBAAA;EAA0B,kBAAA;AA8F5C;AA7FI;EAAc,uBAAA;EAA0B,iBAAA;AAiG5C;AA7FE;EAAW,aAAA;EAAe,sBAAA;EAAwB,MAAA;AAkGpD;AAhGE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AAkGJ;AAhGI;EAAe,iBAAA;AAmGnB;AAjGI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;AAmGN;AAjGI;EAAuB,aAAA;AAoG3B;AAlGI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAoGN;AAjGI;EAAM,iBAAA;EAAmB,gBAAA;EAAkB,iBAAA;AAsG/C;AApGI;EAAa,qBAAA;EAAuB,uBAAA;EAAyB,+BAAA;AAyGjE;AAxGI;EAAa,gBAAA;EAAkB,gBAAA;AA4GnC;AA3GI;EAAe,uBAAA;EAAyB,iCAAA;AA+G5C;AA9GI;EAAe,gBAAA;EAAkB,gBAAA;AAkHrC;AA9GE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,kCAAA;EACA,iCAAA;AAgHJ;AA9GI;EAAe,mBAAA;AAiHnB;AA/GI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAiHN;AA/GM;EAAW,sBAAA;EAA0B,gBAAA;AAmH3C;AAlHM;EAAW,wBAAA;EAA0B,kBAAA;AAsH3C;AArHM;EAAW,qBAAA;EAA0B,gBAAA;AAyH3C;AAtHI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAwHN;AApHE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAsHJ;AApHI;EAAW,sBAAA;AAuHf;AAtHI;EAAW,wBAAA;AAyHf;AAxHI;EAAW,qBAAA;AA2Hf;AAzHI;EAAM,WAAA;EAAa,YAAA;AA6HvB;AAzHE;EACE,eAAA;AA2HJ;AAzHI;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,cAAA;EACA,mCAAA;AA2HN;AAzHM;EAAW,kBAAA;AA4HjB;AAzHI;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA2HN;AAvHE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAyHJ;AAvHI;EAAa,wBAAA;EAA0B,kBAAA;AA2H3C;AA1HI;EAAa,qBAAA;EAA0B,gBAAA;AA8H3C;AA3HE;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA6HJ;AAzHE;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,6FAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AA2HJ;AAzHI;EACE,mBAAA;AA2HN;AA1HM;EAAM,WAAA;AA6HZ;AA1HI;EAAK,WAAA;EAAa,eAAA;EAAiB,gBAAA;EAAkB,kBAAA;EAAoB,eAAA;AAiI7E;AAhII;EAAK,gBAAA;EAAkB,eAAA;EAAiB,kBAAA;EAAoB,gBAAA;EAAkB,gBAAA;EAAkB,gBAAA;AAwIpG;AArIE;EACE,aAAA;EACA,sDAAA;EACA,SAAA;AAuIJ;AApIE;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;AAsIJ;AApII;EAAU,2BAAA;EAA6B,4CAAA;AAwI3C;AAtII;EAAO,eAAA;AAyIX;AAxII;EAAO,gBAAA;EAAkB,gBAAA;EAAkB,iBAAA;EAAmB,eAAA;AA8IlE;AA7II;EAAO,iBAAA;EAAmB,gBAAA;EAAkB,iBAAA;AAkJhD;AA/IE;EAAQ,wBAAA;AAkJV;AA/IE;EACE;IAAS,0BAAA;IAA4B,4BAAA;EAmJvC;EAlJE;IAAS,kBAAA;IAAoB,kCAAA;EAsJ/B;EArJE;IAAW,gBAAA;EAwJb;EAvJE;IAAW,eAAA;IAAiB,QAAA;IAAU,kBAAA;EA4JxC;EA3JE;IAAW,WAAA;IAAa,2BAAA;EA+J1B;EA9JE;IAAW,iBAAA;IAAmB,eAAA;EAkKhC;AACF;AAhKE;EACE;IAAsB,aAAA;EAmKxB;EAlKE;IAAW,cAAA;EAqKb;EApKE;IAAW,oBAAA;EAuKb;EAtKE;IAAY,kBAAA;EAyKd;EAxKE;IAAW,0BAAA;EA2Kb;AACF;;AAvKA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA0KF;AAxKE;EACE,qBAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;AA0KJ;AAxKI;EAAU,qBAAA;EAAuB,uBAAA;AA4KrC","sourcesContent":["// Keyframes (global — noms uniques, pas de risque de collision)\n@keyframes oa-rise {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n@keyframes oa-blink {\n  0%, 60%, 100% { opacity: .25; }\n  30%            { opacity: 1; }\n}\n@keyframes oa-pulse {\n  0%   { box-shadow: 0 0 0 0   rgba(20,20,255,.4); }\n  70%  { box-shadow: 0 0 0 6px rgba(20,20,255,0);  }\n  100% { box-shadow: 0 0 0 0   rgba(20,20,255,0);  }\n}\n\n// ─── Conteneur racine ───────────────────────────────────────────────────────\n#owen-bot {\n  // Variables courtes scopées (n'altèrent pas le reste de l'app)\n  --p1: #f5f5ff; --p2: #d8d8ff; --p3: #8686ff; --p4: #4343ff;\n  --p5: #1414ff; --p6: #0000c9; --p7: #000093; --p8: #00007a; --p9: #000054;\n  --n2: #f9f9fa; --n4: #e0e0e3; --n8: #838390;\n  --ok: #126f0e; --ok1: #f4fced; --ok5: #58b441;\n  --warn: #b94402; --warn1: #fef9f0; --warn3: #fbd298;\n  --dng: #911727; --dng1: #fdf1ed; --dng3: #f4ada1;\n\n  // Co-branding (contractType.coLabeling === 'partner' | 'distributor') : valeurs par\n  // défaut = couleurs Owen actuelles ci-dessus, surchargées en JS (OwenAssistant.js)\n  // uniquement quand une couleur partenaire/distributeur est disponible. Variables\n  // dédiées (plutôt que réutiliser --p5/--p8/... partout) pour ne recolorer QUE les\n  // éléments demandés, sans effet de bord sur le reste (badges de statut, etc.).\n  --cb-accent:       var(--p5); // bouton envoyer, focus champ de saisie, boutons/chips du chat\n  --cb-accent-hover: var(--p6); // état hover des mêmes éléments\n  --cb-border:       var(--p8); // bordure (au repos) du champ de saisie client\n  --cb-reply-bg:     var(--p1); // fond des réponses du coach (même couleur que les modules \"Garanties\" de l'espace client)\n  --cb-reply-text:   var(--p8); // texte des réponses du coach\n  --cb-text:         var(--p8); // couleur de police générale du widget\n  --cb-dark:         var(--p9); // barre overlay du haut, avatar du coach\n  --cb-dot:          var(--ok5); // pastille \"en ligne\"\n\n  // Topbar interne (logo Owen + bouton \"Déclarer le sinistre\") : visible par défaut,\n  // masquée entièrement en co-branding (demandé : un seul bandeau, pas deux) — voir\n  // OwenAssistant.js.\n  --cb-topbar-display: flex;\n\n  // Barre overlay (\"Assistant de protection et de sinistre\") : bleu Owen par défaut,\n  // repasse en gris fixe (fond + texte/logo/boutons) en co-branding.\n  --cb-ovbar-bg:     var(--cb-dark);\n  --cb-ovbar-fg:     #fff;\n  --cb-ovbtn-bg:     rgba(255,255,255,.14);\n  --cb-ovbtn-border: rgba(255,255,255,.28);\n  --cb-ovbtn-hover:  rgba(255,255,255,.26);\n\n  font-family: 'Lexend', sans-serif;\n  font-weight: 300;\n}\n\n// ─── FAB ─────────────────────────────────────────────────────────────────────\n#ob-fab {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: none;\n  cursor: pointer;\n  background: var(--cb-accent);\n  color: #fff;\n  border-radius: 30px;\n  padding: 12px 18px 12px 14px;\n  box-shadow: 0 8px 24px rgba(0,0,21,.28);\n  font-size: 15px;\n  font-weight: 500;\n  font-family: 'Lexend', sans-serif;\n\n  &:hover { background: var(--cb-accent-hover); }\n\n  svg { width: 22px; height: 22px; }\n}\n\n#owen-bot .ob-fab-label { /* visible par défaut, caché en ≤600px */ }\n\n// ─── Overlay ─────────────────────────────────────────────────────────────────\n#ob-overlay {\n  position: fixed;\n  z-index: 60;\n  background: #fff;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 30px 80px rgba(0,0,21,.45);\n  display: flex;\n  flex-direction: column;\n  transition: all .22s ease;\n\n  &[hidden] { display: none; }\n}\n\n.size-sm #ob-overlay {\n  right: 24px;\n  bottom: 24px;\n  left: auto;\n  top: auto;\n  width: 400px;\n  height: 600px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 48px);\n}\n\n.size-lg #ob-overlay {\n  inset: 14px;\n  width: auto;\n  height: auto;\n}\n\n// ─── Barre overlay ───────────────────────────────────────────────────────────\n.ob-ovbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 14px;\n  background: var(--cb-ovbar-bg);\n  color: var(--cb-ovbar-fg);\n  flex: none;\n}\n\n.ob-ovtitle {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  font-size: 13.5px;\n  font-weight: 500;\n  min-width: 0;\n\n  svg  { width: 58px; height: auto; flex: none; }\n  span { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n}\n\n.ob-ovactions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: none;\n}\n\n.ob-ovbtn {\n  background: var(--cb-ovbtn-bg);\n  border: 1px solid var(--cb-ovbtn-border);\n  color: inherit;\n  border-radius: 8px;\n  padding: 7px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: inherit;\n  white-space: nowrap;\n\n  &:hover { background: var(--cb-ovbtn-hover); }\n}\n\n.ob-icobtn {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  line-height: 1;\n}\n\n// Bascule agrandir/réduire\n.size-sm .ob-tg-shrink { display: none; }\n.size-lg .ob-tg-grow   { display: none; }\n\n// Mode réduit : masquer dossier et topbar interne\n.size-sm #ob-asst .stage   { grid-template-columns: 1fr; }\n.size-sm #ob-asst .dossier { display: none; }\n.size-sm #ob-asst .topbar  { display: none; }\n.size-sm #ob-asst .chat    { border-right: none; }\n\n// Lien \"Espace client\" masqué en mode embed (on est déjà dans l'app)\n.embed .tbtn.espace { display: none; }\n\n// ─── Responsive overlay ──────────────────────────────────────────────────────\n@media (max-width: 600px) {\n  #owen-bot .ob-fab-label { display: none; }\n\n  .size-sm #ob-overlay,\n  .size-lg #ob-overlay {\n    inset: 0;\n    width: auto;\n    height: auto;\n    max-width: none;\n    max-height: none;\n    border-radius: 0;\n  }\n\n  .size-sm #ob-asst .stage  { grid-template-columns: 1fr; grid-template-rows: 1fr; }\n  .size-sm #ob-asst .dossier { display: none; }\n  .size-lg #ob-asst .stage   { grid-template-columns: 1fr; grid-template-rows: 1fr auto; }\n  .size-lg #ob-asst .dossier { max-height: 38vh; }\n\n  .ob-ovbar { padding: 9px 12px; }\n  .ob-ovtitle span { display: none; }\n  .ob-ovbtn { padding: 6px 10px; font-size: 12px; }\n}\n\n// ─── Assistant interne (#ob-asst) ────────────────────────────────────────────\n#ob-asst {\n  * { box-sizing: border-box; font-family: 'Lexend', sans-serif; }\n\n  position: relative;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  background: var(--n2);\n  color: var(--cb-text);\n\n  a { color: inherit; }\n\n  // ── Topbar interne ────────────────────────────────────────────────────────\n  .topbar {\n    display: var(--cb-topbar-display);\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 28px;\n    background: var(--cb-dark);\n    color: #fff;\n    flex: none;\n\n    .brand {\n      display: flex;\n      align-items: center;\n      gap: 14px;\n\n      svg { width: 78px; height: auto; }\n    }\n\n  }\n\n  .tbtns {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n\n  .tbtn {\n    background: rgba(255,255,255,.12);\n    border: 1px solid rgba(255,255,255,.28);\n    color: #fff;\n    border-radius: 8px;\n    padding: 8px 13px;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n    font-family: inherit;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n\n    &:hover { background: rgba(255,255,255,.22); }\n    &.on { background: #fff; color: var(--cb-dark); }\n  }\n\n  .embed .tbtn.espace { display: none; }\n\n  // ── Stage (chat + dossier) ────────────────────────────────────────────────\n  .stage {\n    flex: 1;\n    display: grid;\n    grid-template-columns: 1.05fr .95fr;\n    gap: 0;\n    min-height: 0;\n\n    &.solo { grid-template-columns: 1fr; }\n    &.solo .dossier { display: none; }\n  }\n\n  // ── Chat ──────────────────────────────────────────────────────────────────\n  .chat {\n    position: relative; // ancre le panneau .ob-info-tooltip, superposé au-dessus du fil de messages\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    border-right: 1px solid var(--n4);\n    background: #fff;\n  }\n\n  .chat-head {\n    padding: 16px 22px;\n    border-bottom: 1px solid var(--n4);\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    .av {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      background: var(--cb-dark);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      svg { width: 30px; }\n    }\n\n    .nm { font-weight: 600; font-size: 16px; }\n    .st { font-size: 12px; color: var(--n8); }\n    .dot {\n      width: 8px;\n      height: 8px;\n      border-radius: 50%;\n      background: var(--cb-dot);\n      display: inline-block;\n      margin-right: 5px;\n    }\n\n    .ob-download-btn {\n      margin-left: auto;\n      flex: 0 0 auto;\n      width: 36px;\n      height: 36px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0;\n      border-radius: 50%;\n      border: 1px solid var(--n4);\n      background: #fff;\n      color: var(--p6);\n      font-size: 16px;\n      cursor: pointer;\n\n      &:hover { background: var(--n2); }\n    }\n  }\n\n  .log {\n    flex: 1;\n    overflow-y: auto;\n    padding: 22px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    background: linear-gradient(180deg, #fff, var(--n2));\n  }\n\n  .msg {\n    max-width: 82%;\n    padding: 11px 15px;\n    border-radius: 16px;\n    font-size: 14.5px;\n    line-height: 1.55;\n    white-space: pre-wrap;\n    animation: oa-rise .35s ease both;\n  }\n\n  .bot  { align-self: flex-start; background: var(--cb-reply-bg); color: var(--cb-reply-text); border-bottom-left-radius: 5px; }\n  .user { align-self: flex-end;   background: var(--p5); color: #fff;       border-bottom-right-radius: 5px; }\n  .bot  strong { color: var(--cb-accent); }\n  .user strong { color: #fff; }\n\n  // Message d'alerte — justificatif rejeté par la vérification IA\n  .msg.alert {\n    background: var(--warn1);\n    color: var(--warn);\n    border: 1px solid var(--warn3);\n    strong { color: var(--warn); }\n  }\n\n  .sys {\n    align-self: center;\n    font-size: 12.5px;\n    color: var(--n8);\n    background: #fff;\n    border: 1px dashed var(--n4);\n    border-radius: 20px;\n    padding: 5px 14px;\n  }\n\n  .typing-wrap {\n    align-self: flex-start;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    animation: oa-rise .35s ease both;\n  }\n\n  .typing-who {\n    font-size: 12px;\n    color: var(--p5);\n    font-style: italic;\n    padding-left: 4px;\n  }\n\n  .typing {\n    align-self: flex-start;\n    display: flex;\n    gap: 5px;\n    padding: 13px 16px;\n    background: var(--p1);\n    border-radius: 16px;\n    border-bottom-left-radius: 5px;\n\n    span {\n      width: 7px;\n      height: 7px;\n      border-radius: 50%;\n      background: var(--p3);\n      animation: oa-blink 1s infinite;\n\n      &:nth-child(2) { animation-delay: .18s; }\n      &:nth-child(3) { animation-delay: .36s; }\n    }\n  }\n\n  .quick {\n    padding: 0 22px 12px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 9px;\n    background: var(--n2);\n  }\n\n  .composer {\n    display: flex;\n    gap: 8px;\n    padding: 12px 22px;\n    border-top: 1px solid var(--n4);\n    background: #fff;\n\n    textarea {\n      flex: 1;\n      height: 42px;\n      max-height: 120px;\n      padding: 10px 14px;\n      border: 1px solid var(--cb-border);\n      border-radius: 10px;\n      outline: none;\n      font-family: inherit;\n      font-size: 14.5px;\n      line-height: 1.4;\n      color: var(--p8);\n      resize: none;\n      overflow-y: auto;\n\n      &:focus { border-color: var(--cb-accent); }\n    }\n\n    button {\n      align-self: flex-end;\n      border: none;\n      background: var(--cb-accent);\n      color: #fff;\n      border-radius: 10px;\n      padding: 0 18px;\n      height: 42px;\n      font-weight: 600;\n      cursor: pointer;\n      font-family: inherit;\n\n      &:hover  { background: var(--cb-accent-hover); }\n      &:disabled { background: var(--p2); cursor: default; }\n    }\n  }\n\n  // ── Chips de suggestion ───────────────────────────────────────────────────\n  .chip {\n    border: 1px solid var(--cb-accent);\n    background: #fff;\n    color: var(--cb-accent-hover);\n    border-radius: 20px;\n    padding: 9px 15px;\n    font-size: 13.5px;\n    font-weight: 500;\n    cursor: pointer;\n    font-family: inherit;\n    animation: oa-rise .3s ease both;\n    transition: .12s;\n\n    &:hover  { background: var(--cb-reply-bg); }\n    &.cta    { background: var(--cb-accent); color: #fff; border-color: var(--cb-accent); }\n    &.cta:hover { background: var(--cb-accent-hover); }\n    &.ghost  { border-color: var(--n4); color: var(--n8); }\n    &.adu-chip-done { border-color: #3a9c3a; color: #3a9c3a; background: #f0faf0; cursor: default; }\n    // Justificatif rejeté par la vérification IA — reste cliquable pour réessayer.\n    &.adu-chip-rejected { border-color: #d64545; color: #d64545; background: #fdecec; }\n    // Justificatif confirmé par le client malgré une alerte IA — transmis tel quel à un agent.\n    &.adu-chip-forced { border-color: var(--warn); color: var(--warn); background: var(--warn1); cursor: default; }\n  }\n\n  // ── Bouton inline dans le chat ───────────────────────────────────────────\n  .msg-inline-action {\n    align-self: flex-start;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    animation: oa-rise .35s ease both;\n\n    .inline-cta {\n      background: var(--cb-accent);\n      color: #fff;\n      border: none;\n      border-radius: 20px;\n      padding: 10px 20px;\n      font-size: 14px;\n      font-weight: 600;\n      font-family: inherit;\n      cursor: pointer;\n      transition: background .12s;\n\n      &:hover    { background: var(--cb-accent-hover); }\n      &:disabled { background: var(--p3); cursor: default; }\n    }\n\n    .inline-ghost {\n      background: #fff;\n      color: var(--cb-accent-hover);\n      border: 1px solid var(--cb-accent);\n      border-radius: 20px;\n      padding: 10px 20px;\n      font-size: 14px;\n      font-weight: 500;\n      font-family: inherit;\n      cursor: pointer;\n      transition: background .12s;\n\n      &:hover { background: var(--cb-reply-bg); }\n    }\n  }\n\n  // ── Icône ℹ️ discrète (dans le message d'ouverture) + panneau d'info superposé ──\n  // Le panneau (.ob-info-tooltip) est un enfant direct de .chat, pas de la bulle du message :\n  // sa position (top/left) est calculée en JS depuis la position de l'icône, pour qu'il flotte\n  // toujours par-dessus le fil de messages (y compris les bulles ajoutées après), jamais dessous.\n  .ob-info-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 17px;\n    height: 17px;\n    margin-left: 4px;\n    padding: 0;\n    background: none;\n    border: none;\n    cursor: pointer;\n    vertical-align: middle;\n    color: var(--p9);\n\n    svg { width: 100%; height: 100%; }\n\n    &:hover { color: var(--p6); }\n  }\n\n  .ob-info-tooltip {\n    position: absolute;\n    z-index: 30;\n    width: 240px;\n    max-width: calc(100vw - 64px);\n    background: #fff;\n    color: var(--p8);\n    border: 1px solid var(--n4);\n    border-radius: 12px;\n    box-shadow: 0 10px 28px rgba(0,0,0,.18);\n    padding: 16px 14px 14px;\n    font-size: 12.5px;\n    line-height: 1.5;\n    font-weight: 400;\n\n    &[hidden] { display: none; }\n\n    .ob-info-close {\n      position: absolute;\n      top: 8px;\n      right: 8px;\n      background: none;\n      border: none;\n      color: var(--n8);\n      font-size: 13px;\n      line-height: 1;\n      padding: 4px;\n      cursor: pointer;\n\n      &:hover { color: var(--p8); }\n    }\n\n    // Contenu scrollable — la croix ci-dessus reste fixe pendant le scroll\n    .ob-info-body {\n      max-height: 280px; // valeur de repli, recalculée en JS selon la place dispo sous l'icône\n      overflow-y: auto;\n\n      // Scrollable mais sans barre visible (le geste de scroll suffit, pas de rail à l'écran)\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n\n      &::-webkit-scrollbar { display: none; }\n\n      p { margin: 0 0 8px; }\n      a { display: inline-block; margin-bottom: 8px; color: var(--p5); font-weight: 500; }\n\n      .ob-info-human-btn {\n        display: block;\n        width: 100%;\n        margin-top: 4px;\n        background: var(--p1);\n        border: none;\n        border-radius: 10px;\n        padding: 8px 10px;\n        font-size: 12.5px;\n        font-weight: 600;\n        font-family: inherit;\n        color: var(--p6);\n        cursor: pointer;\n\n        &:hover { background: var(--p2); }\n      }\n    }\n  }\n\n  // ── Dossier d'audit ───────────────────────────────────────────────────────\n  .dossier {\n    overflow-y: auto;\n    padding: 22px;\n    background: var(--n2);\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    // Scrollable mais sans barre visible (le geste de scroll suffit, pas de rail à l'écran)\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n\n    &::-webkit-scrollbar { display: none; }\n\n    h2 {\n      font-size: 12px;\n      letter-spacing: .08em;\n      text-transform: uppercase;\n      color: var(--n8);\n      margin: 0 0 2px;\n    }\n  }\n\n  .panel {\n    background: #fff;\n    border: 1px solid var(--n4);\n    border-radius: 14px;\n    padding: 16px 18px;\n\n    &.empty { opacity: .45; }\n\n    .ttl {\n      font-size: 13px;\n      font-weight: 600;\n      color: var(--p7);\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin-bottom: 10px;\n    }\n  }\n\n  .kv {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 13.5px;\n    padding: 3px 0;\n\n    .k { color: var(--n8); }\n    .v { font-weight: 500; text-align: right; }\n  }\n\n  .badge {\n    display: inline-block;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 2px 9px;\n    border-radius: 20px;\n\n    &.risk-low  { background: var(--ok1);   color: var(--ok); }\n    &.risk-med  { background: var(--warn1); color: var(--warn); }\n    &.risk-high { background: var(--dng1);  color: var(--dng); }\n  }\n\n  // Tracker étapes\n  .tracker { display: flex; flex-direction: column; gap: 0; }\n\n  .tstep {\n    display: flex;\n    gap: 11px;\n    align-items: flex-start;\n    position: relative;\n    padding-bottom: 14px;\n\n    &:last-child { padding-bottom: 0; }\n\n    &::before {\n      content: '';\n      position: absolute;\n      left: 8px;\n      top: 18px;\n      bottom: 0;\n      width: 2px;\n      background: var(--n4);\n    }\n    &:last-child::before { display: none; }\n\n    .ic {\n      width: 18px;\n      height: 18px;\n      border-radius: 50%;\n      border: 2px solid var(--n4);\n      background: #fff;\n      flex: none;\n      margin-top: 1px;\n      transition: .25s;\n    }\n\n    .lb { font-size: 13.5px; color: var(--n8); transition: .25s; }\n\n    &.done .ic { background: var(--p5); border-color: var(--p5); box-shadow: 0 0 0 3px var(--p1); }\n    &.done .lb { color: var(--p8); font-weight: 500; }\n    &.active .ic { border-color: var(--p5); animation: oa-pulse 1.2s infinite; }\n    &.active .lb { color: var(--p6); font-weight: 600; }\n  }\n\n  // Lignes documents / contrôles\n  .row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 13.5px;\n    padding: 7px 0;\n    border-bottom: 1px solid var(--n2);\n    animation: oa-rise .3s ease both;\n\n    &:last-child { border-bottom: none; }\n\n    .st {\n      margin-left: auto;\n      font-size: 11px;\n      font-weight: 600;\n      padding: 2px 8px;\n      border-radius: 20px;\n\n      &.ok     { background: var(--ok1);   color: var(--ok); }\n      &.review { background: var(--warn1); color: var(--warn); }\n      &.wait   { background: var(--p1);    color: var(--p6); }\n    }\n\n    .ocr {\n      display: block;\n      font-size: 11.5px;\n      color: var(--n8);\n      font-weight: 400;\n      margin-top: 2px;\n    }\n  }\n\n  .chk {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    flex: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &.ok     { background: var(--ok5); }\n    &.review { background: var(--warn3); }\n    &.wait   { background: var(--n4); }\n\n    svg { width: 10px; height: 10px; }\n  }\n\n  // Calcul décision\n  .calc {\n    margin-top: 4px;\n\n    .line {\n      display: flex;\n      justify-content: space-between;\n      font-size: 13.5px;\n      padding: 5px 0;\n      border-bottom: 1px dashed var(--n4);\n\n      &.neg .v { color: var(--warn); }\n    }\n\n    .total {\n      display: flex;\n      justify-content: space-between;\n      font-size: 16px;\n      font-weight: 700;\n      color: var(--p8);\n      padding-top: 9px;\n    }\n  }\n\n  .dstat {\n    display: inline-block;\n    font-size: 12px;\n    font-weight: 600;\n    padding: 4px 12px;\n    border-radius: 20px;\n    margin-bottom: 10px;\n\n    &.partial  { background: var(--warn1); color: var(--warn); }\n    &.escalate { background: var(--p1);    color: var(--p6); }\n  }\n\n  .note {\n    font-size: 12.5px;\n    color: var(--n8);\n    margin-top: 10px;\n    line-height: 1.5;\n  }\n\n  // ── Picker de scénarios ───────────────────────────────────────────────────\n  .picker {\n    position: absolute;\n    inset: 0;\n    background: var(--p9);\n    background-image: radial-gradient(circle at 80% 10%, rgba(67,67,255,.4), transparent 45%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 30px;\n    z-index: 20;\n\n    .logo {\n      margin-bottom: 18px;\n      svg { width: 96px; }\n    }\n\n    h1 { color: #fff; font-size: 30px; font-weight: 600; text-align: center; margin: 0 0 6px; }\n    p  { color: var(--p2); font-size: 15px; text-align: center; max-width: 520px; margin: 0 0 28px; font-weight: 300; }\n  }\n\n  .cards {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(220px, 260px));\n    gap: 14px;\n  }\n\n  .scard {\n    background: #fff;\n    border-radius: 14px;\n    padding: 18px;\n    cursor: pointer;\n    border: 1px solid transparent;\n    transition: .15s;\n    text-align: left;\n\n    &:hover { transform: translateY(-3px); box-shadow: 0 14px 30px rgba(0,0,21,.35); }\n\n    .emo { font-size: 24px; }\n    .t   { font-weight: 600; color: var(--p8); margin: 8px 0 3px; font-size: 16px; }\n    .d   { font-size: 12.5px; color: var(--n8); line-height: 1.45; }\n  }\n\n  .hide { display: none !important; }\n\n  // ── Responsive interne ────────────────────────────────────────────────────\n  @media (max-width: 880px) {\n    .stage { grid-template-columns: 1fr; grid-template-rows: 1fr auto; }\n    .chat  { border-right: none; border-bottom: 1px solid var(--n4); }\n    .dossier { max-height: 40vh; }\n    .topbar  { flex-wrap: wrap; gap: 8px; padding: 10px 14px; }\n    .tbtns   { width: 100%; justify-content: flex-start; }\n    .tbtn    { padding: 7px 10px; font-size: 12px; }\n  }\n\n  @media (max-width: 600px) {\n    .topbar .brand .tag { display: none; }\n    .msg     { max-width: 90%; }\n    .quick   { padding: 0 14px 10px; }\n    .composer { padding: 10px 14px; }\n    .cards   { grid-template-columns: 1fr; }\n  }\n}\n\n// ─── Suggestions autocomplete ────────────────────────────────────────────────\n.composer-suggestions {\n  padding: 0 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n\n  .sugg-item {\n    background: var(--n2);\n    border: 1px solid var(--n4);\n    border-radius: 8px;\n    padding: 6px 10px;\n    font-size: 12px;\n    font-weight: 300;\n    font-family: 'Lexend', sans-serif;\n    color: var(--p7);\n    text-align: left;\n    cursor: pointer;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    transition: background .15s;\n\n    &:hover { background: var(--p1); border-color: var(--p3); }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
